import { initializeApp } from "firebase/app";
import {
  deleteToken,
  getMessaging,
  getToken,
  onMessage,
} from "firebase/messaging";
import { updateARN } from "../service";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { App, Button, Space } from "antd";

const firebaseConfig = {
  apiKey: "AIzaSyCRMAlf6SqdSkaVuvPFOoz8O4Pb7oPjLKA",
  authDomain: "ghoshak-991ff.firebaseapp.com",
  databaseURL: "https://ghoshak-991ff.firebaseio.com",
  projectId: "ghoshak-991ff",
  storageBucket: "ghoshak-991ff.appspot.com",
  messagingSenderId: "306673479060",
  appId: "1:306673479060:web:e939e0c8730de7f23af381",
};

initializeApp(firebaseConfig);
const messaging = getMessaging();

const requestForToken = async (shopId, existingToken) => {
  const arnMutation = async (currentToken) => {
    console.log("arnMutationCurrentToken", currentToken);
    let token = existingToken;
    if (typeof token == "string") {
      const newTokenStructure = {
        mobileTokens: [token],
        webTokens: [currentToken],
      };
      await updateARN(newTokenStructure, shopId);
    } else if (typeof token === "object") {
      if (token.hasOwnProperty("webTokens")) {
        console.log(
          "hasOwnProperty1",
          token.webTokens,
          token.webTokens?.includes(currentToken)
        );
        if (!token.webTokens?.includes(currentToken)) {
          token.webTokens?.push(currentToken);
          await updateARN(token, shopId);
        }
      } else {
        token.webTokens = [currentToken];
        await updateARN(token, shopId);
      }
    }
  };

  return getToken(messaging, {
    vapidKey:
      "BBmerUjzQMFBmj-rFqs-bVtu2orWD4hVA-8_e_xF0brabOtjI7QYvB3KEhmVp5mzCnpRO2KHxLQcSfTAPG_eK_w",
  })
    .then((currentToken) => {
      console.log("currentToken", currentToken, shopId, existingToken);
      if (currentToken && shopId) {
        arnMutation(currentToken);
      } else if (!currentToken) {
        // Show permission request UI
        requestPermission(shopId, existingToken);
        console.error(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.error("An error occurred while retrieving token. ", err);
    });
};

const requestPermission = async (shopData = {}) => {
  const shopId = shopData.shopId;
  const existingToken = shopData.userEndpointARN;
  const permission = await Notification.requestPermission();
  console.log("permission", permission, shopData, shopId, existingToken);
  if (permission === "granted") {
    await requestForToken(shopId, existingToken);
    console.log("Notification permission granted.");
  } else {
    console.log("Unable to get permission to notify.");
  }
};

const openNotification = ({ notificationApi, title, body }) => {
  const key = `open${Date.now()}`;
  const btn = (
    <Space>
      <Button
        type="link"
        size="small"
        onClick={() => notificationApi.destroy()}
      >
        Destroy All
      </Button>
      <Button
        type="primary"
        size="small"
        onClick={() => notificationApi.destroy(key)}
      >
        Confirm
      </Button>
    </Space>
  );
  notificationApi.open({
    message: title,
    description: body,
    btn,
    key,
  });
};

export const usePushNotification = () => {
  const { notification: antdNotification } = App.useApp();
  const shopDetails = useSelector((state) => state.shopDetails);
  console.log("shopDetails9873", shopDetails.userEndpointARN);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      console.log("messageReceived", payload);
      const notificationData = payload.notification;
      if (!document.hidden) {
        openNotification({
          notificationApi: antdNotification,
          title: notificationData.title,
          body: notificationData.body,
        });
      } else {
        const notificationApi = new Notification(notificationData.title, {
          body: notificationData.body,
          icon: window.location.origin + "/favicon.png",
        });

        setTimeout(() => {
          notificationApi.close();
        }, 10 * 5000);

        notificationApi.addEventListener("click", () => {
          window.open(window.location.origin + "/#/dashboard/shop-items");
        });
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return requestPermission;
};

export const removePushNotificationToken = async (shopId, tokenData) => {
  if (Notification.permission === "granted") {
    try {
      const token = await getToken(messaging);
      tokenData.webTokens = tokenData?.webTokens?.filter(
        (webToken) => webToken !== token
      );
      await updateARN(tokenData, shopId);
      const deleteResponse = await deleteToken(messaging);
      return deleteResponse;
    } catch (error) {
      console.log("removePushNotificationTokenError", error);
    }
  }
};
